// Self-serve phone 4b-3: shared dialer context. There is exactly ONE Twilio
// Device app-wide (held by VoiceDialerProvider via useVoiceDevice). Any surface
// (ContactPanel, CallHistory, CustomerDetail, Leads, Phone setup) triggers the
// same floating dialer through openDialer().

import { createContext, useContext } from 'react'
import type { useVoiceDevice } from '../../hooks/useVoiceDevice'

export type VoiceApi = ReturnType<typeof useVoiceDevice>

export interface DialerPrefill {
  // bumped on every openDialer() so the dialer re-seeds its number even when
  // the same number is requested twice.
  key: number
  number: string
  contactType: string | null
  contactId: string | null
}

export interface DialerContextValue {
  voice: VoiceApi
  prefill: DialerPrefill
  open: boolean
  openDialer: (opts?: {
    number?: string
    contactType?: string | null
    contactId?: string | null
  }) => void
  closeDialer: () => void
}

export const DialerContext = createContext<DialerContextValue | null>(null)

export function useDialer(): DialerContextValue {
  const ctx = useContext(DialerContext)
  if (!ctx) throw new Error('useDialer must be used within a VoiceDialerProvider')
  return ctx
}
